"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.string.sub");

require("core-js/modules/es6.promise");

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var NotificationsHubAuthorizer =
/*#__PURE__*/
function () {
  function NotificationsHubAuthorizer(_ref) {
    var centralizedAuth = _ref.centralizedAuth,
        _ref$env = _ref.env,
        env = _ref$env === void 0 ? "int" : _ref$env;

    _classCallCheck(this, NotificationsHubAuthorizer);

    this.centralizedAuth = centralizedAuth;
    this.subscriptionsUrl = "https://".concat(getPrefix(env), "subscriptions.commerce.cimpress.io");
    this.centralUrl = "https://".concat(getPrefix(env), "central.mex.cimpress.io");
  }

  _createClass(NotificationsHubAuthorizer, [{
    key: "ensureAuthorized",
    value: function ensureAuthorized() {
      var _this = this;

      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$returnUri = _ref2.returnUri,
          returnUri = _ref2$returnUri === void 0 ? window.location.href : _ref2$returnUri;

      return this.didUserAuthorize().then(function (authorized) {
        if (!authorized) {
          window.location.assign("".concat(_this.centralUrl, "/subscriptions/authorize?returnUri=").concat(returnUri));
        }

        return Promise.resolve(authorized);
      });
    }
  }, {
    key: "didUserAuthorize",
    value: function didUserAuthorize() {
      var _this2 = this;

      var principal = this.centralizedAuth.getProfile()["https://claims.cimpress.io/email"] || this.centralizedAuth.getProfile().sub;
      return fetch("".concat(this.subscriptionsUrl, "/v1/users/").concat(principal), {
        method: "GET",
        mode: "cors",
        headers: new Headers({
          Accept: "application/json",
          Authorization: "Bearer ".concat(this.centralizedAuth.getAccessToken())
        })
      }).then(function (res) {
        if (res.ok) {
          return true;
        }

        if (res.status === 404) {
          return false;
        }

        return _this2.handleError("Error retrieving user", res);
      });
    }
  }, {
    key: "handleError",
    value: function handleError(message, response) {
      return response.json().then(function (body) {
        var err = new Error("".concat(message, ": (").concat(response.status, ") ").concat(response.statusText));
        err.cause = body;
        throw err;
      });
    }
  }]);

  return NotificationsHubAuthorizer;
}();

exports.default = NotificationsHubAuthorizer;

function getPrefix(env) {
  return env === "prd" || env === "production" ? "" : "int-";
}